import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "../style.scss";
import AdminService from "../../../../../services/AdminService";
import RoleService from "../../../../../services/RoleService";
import { Translate } from "../../../../Enums/Tranlate";
import WorkShiftService from "../../../../../services/WorkShiftService";
import BaseService from "../../../../../services/BaseService";

const AddAdminsModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		username: "",
		phone: "",
		email: "",
		role: "",
		password: "",
		isActive: "active",
		licence_number: "",
		work_shift: "",
		license_image: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [rolesOptions, setRolesOptions] = useState([]);
	const [workShiftOptions, setWorkShiftOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const adminService = new AdminService();
	const roleService = new RoleService();
	const workShiftService = new WorkShiftService();

	useEffect(() => {
		Promise.all([
			roleService.getList(),
			workShiftService?.getList(),
			// zoneService?.getList(),
		]).then((res) => {
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setRolesOptions(data);
			}
			if (res[1]?.status === 200) {
				let data = res[1]?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setWorkShiftOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					name: item?.username,
					isActive: item?.status,
					email: item?.email,
					phone: item?.phone,
					role: {
						label: item?.admin_permissions[0]?.admin_role?.name,
						value: item?.admin_permissions[0]?.admin_role_id,
					},
					licence_number: item?.license_number,
					work_shift: {
						label: item?.work_shift?.name,
						value: item?.work_shift?.id,
					},
					license_image: item?.license_image || "",
				});
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.role?.value) {
			return;
		}
		let data = {
			username: formData?.name,
			phone: formData?.phone,
			email: formData?.email,
			role_id: formData?.role?.value,
			password: formData?.password,
			status: formData?.isActive,
		};
		if (formData?.licence_number)
			data["license_number"] = formData?.licence_number;
		if (formData?.work_shift) data["shift_id"] = formData?.work_shift?.value;
		if (formData?.license_image)
			data["license_image"] = formData?.license_image;

		setLoading(true);
		if (isAdd) {
			adminService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			if (!formData?.license_image) {
				toast.error("Upload License/Civil Id");
				setLoading(false);
				return;
			}
			adminService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData({ ...formData, [name]: res.data.url });
			}
		});
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.admin}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>

						{/* Role */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.role}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.role}
								name="role"
								placeholder={Translate[lang]?.select}
								options={rolesOptions}
								onChange={(e) => setFormData({ ...formData, role: e })}
							/>
						</Col>
						{/* Name */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Phone */}
						<Col md={6} className="mb-3">
							<label>
								{Translate[lang]?.phone}
								<span className="star-require">*</span>
							</label>
							<PhoneInput
								country={"kw"}
								enableSearch={true}
								value={formData?.phone}
								onChange={(e) => setFormData({ ...formData, phone: e })}
							/>
						</Col>
						{/* Email */}
						<Col md={6}>
							<label>
								{Translate[lang]?.email}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="email"
								placeholder={Translate[lang]?.email}
								bsSize="lg"
								name="email"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.email}
								onChange={(e) =>
									setFormData({
										...formData,
										email: e.target.value,
									})
								}
							/>
						</Col>
						{/* Password */}
						{isAdd && (
							<Col md={6} className="form-group mb-0 position-relative">
								<label>
									{Translate[lang]?.password}
									<span className="star-require">*</span>
								</label>
								<AvField
									type={showPassword ? "text" : "password"}
									placeholder={Translate[lang]?.password}
									bsSize="lg"
									className="radius-10"
									name="password"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.password}
									onChange={(e) =>
										setFormData({
											...formData,
											password: e.target.value,
										})
									}
								/>
								{showPassword ? (
									<i
										className="la la-eye-slash position-absolute cursor-pointer"
										style={{
											top: "44px",
											right: lang === "en" ? "8%" : "auto",
											left: lang === "ar" ? "8%" : "auto",
										}}
										onClick={() => setShowPassword(false)}></i>
								) : (
									<i
										className="la la-eye position-absolute cursor-pointer"
										style={{
											top: "44px",
											right: lang === "en" ? "8%" : "auto",
											left: lang === "ar" ? "8%" : "auto",
										}}
										onClick={() => setShowPassword(true)}></i>
								)}
							</Col>
						)}
						{/* Licence Number */}
						<Col md={6}>
							<AvField
								label={Translate[lang]?.licence_number}
								type="text"
								placeholder={Translate[lang]?.licence_number}
								bsSize="lg"
								name="licence_number"
								value={formData.licence_number}
								validate={{
									required: {
										value: !isAdd,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onChange={(e) =>
									setFormData({
										...formData,
										licence_number: e.target.value,
									})
								}
							/>
						</Col>
						{/* Zone */}
						{/* Upload Image (License/Civil Id) */}
						<Col md={6}>
							<label className="text-label mb-0">
								{Translate[lang].upload_image_admin}
							</label>
							<div className="upload">
								<input
									type="file"
									name="license_image"
									id="license_image"
									onChange={(e) => fileHandler(e, "license_image")}
								/>
								<p>{Translate[lang].upload_image}</p>
								{!formData?.license_image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.license_image && (
								<img
									src={formData?.license_image}
									alt="license_image"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>
						{/* Work Shift */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.work_shift}
							</label>
							<Select
								value={formData?.work_shift}
								name="work_shift"
								placeholder={Translate[lang]?.select}
								options={workShiftOptions}
								onChange={(e) => setFormData({ ...formData, work_shift: e })}
							/>
						</Col>
						{/* Status */}
						<Col md={12} className="mt-3">
							<label className="text-label">{Translate[lang]?.status}</label>
							<div className="d-flex gap-16">
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="active"
										checked={formData?.isActive === "active"}
										onChange={() =>
											setFormData({ ...formData, isActive: "active" })
										}
									/>{" "}
									{Translate[lang]?.active}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="inactive"
										checked={formData?.isActive === "inactive"}
										onChange={() =>
											setFormData({ ...formData, isActive: "inactive" })
										}
									/>{" "}
									{Translate[lang]?.deactive}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="vacation"
										checked={formData?.isActive === "vacation"}
										onChange={() =>
											setFormData({ ...formData, isActive: "vacation" })
										}
									/>{" "}
									{Translate[lang]?.vacation}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="status"
										value="break"
										checked={formData?.isActive === "break"}
										onChange={() =>
											setFormData({ ...formData, isActive: "break" })
										}
									/>{" "}
									{Translate[lang]?.break}
								</label>
							</div>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.admin}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddAdminsModal;
